import React, { useEffect, useState } from 'react'
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronCircleUp } from '@fortawesome/free-solid-svg-icons'
import { CSSTransition } from 'react-transition-group'
config.autoAddCss = false

const ScrollButton = () => {
  const [showButton, setShowButton] = useState(false)

  function handleScroll() {
    const y = window.scrollY
    if (y > 200) {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  function handleClick() {
    window.scrollTo(0, 0)
  }

  const btnStyle = {
    backgroundColor: 'inherit',
    position: 'fixed',
    right: 15,
    bottom: 15,
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
  }

  const iconStyle = {
    color: '#024a62',
  }

  return (
    <>
      <CSSTransition classNames="fade-in-out" timeout={300}>
        {showButton ? (
          <button style={btnStyle} onClick={() => handleClick()} type="button" key="button">
            <FontAwesomeIcon icon={faChevronCircleUp} size="2x" style={iconStyle} />
          </button>
        ) : (
          <></>
        )}
      </CSSTransition>
    </>
  )
}

export default ScrollButton
